import React from 'react';
import { Link } from 'react-router-dom';
import { PesquisaTorneioItem } from '../services/pesquisaService';

interface TorneioCardPesquisaProps {
    torneio: PesquisaTorneioItem;
}

const TorneioCardPesquisa: React.FC<TorneioCardPesquisaProps> = ({ torneio }) => {
    const imagem = torneio.avatarUrl ?? '/assets/images/rede-beach.png';
    return (
        <Link
            to={`/tournamentsingle/${torneio.id}`}
            // Sem `mb-3`: ela CONFLITA com `h-100`. Com altura 100% da coluna, a
            // margem fica FORA da caixa do card e transborda a coluna em vez de
            // separar as linhas — os cards se encostavam (achado de QA do owner,
            // 2026-08-31). O espaçamento vertical passou a ser responsabilidade
            // do grid, via `gy-3` na `.row` de `SearchPage.tsx`, que é onde ele
            // pertence: quem sabe a distância entre linhas é o container, não o
            // filho.
            className="card w-100 border-0 shadow-xss rounded-xxl overflow-hidden h-100 text-decoration-none"
        >
            <div className="card-body d-flex p-3 align-items-center">
                <img
                    src={imagem}
                    alt={torneio.nome}
                    className="rounded-circle"
                    style={{ width: 48, height: 48, objectFit: 'cover' }}
                />
                <div className="ms-3">
                    <span className="fw-700 text-grey-900 font-xssss d-block">{torneio.nome}</span>
                    {torneio.username && (
                        <p className="font-xssss text-grey-500 mb-0">@{torneio.username}</p>
                    )}
                    {torneio.status && (
                        <span className="badge bg-secondary font-xssss">{torneio.status}</span>
                    )}
                </div>
            </div>
        </Link>
    );
};

export default TorneioCardPesquisa;
